import React from 'react';
import { FormField } from 'react-hooks-form';
import DateTime from 'packages/ui/DateTime';

function DateTimeFieldWrapper({ onChange, name, value, ...rest }) {
  return <DateTime {...rest} onChange={val => onChange(val)} value={value || ''} />;
}

function DateTimeField({ name, ...rest }) {
  return <FormField {...rest} component={DateTimeFieldWrapper} name={name} />;
}

export default DateTimeField;
